import React, { Component } from 'react';
import { Form, Field } from 'redux-form';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import {
  RenderTextField as TextField, RenderDropDownField as DropDown,
  RenderRadioGroupField as RadioGroup, RenderSwitchField as Switch
} from '../../formInputs';
import UploadField from '../../formInputs/UploadField';
import FilesList from '../FileLists';
// import { green500 } from 'material-ui/styles/colors';
import Message from '../Message';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import { required } from '../../utils/validations';
import { USER_FILES_FOLDER } from '../../constants';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  success: {
    // backgroundColor: green500,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    marginTop: 10,
    color: '#ffffff',
    backgroundColor: theme.palette.error.dark,
  },
  snackbar: {
    margin: theme.spacing.unit,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  title: {
    marginTop: 10,
  }
});

class UserForm extends Component {
  static propTypes = {
    classes: PropTypes.object,
    handleSubmit: PropTypes.func,
    dakk: PropTypes.object,
    user: PropTypes.object,
    removeMessage: PropTypes.func,
    buttonText: PropTypes.string,
    formType: PropTypes.string,
    error: PropTypes.string
  };

  state = {
    isVerified: this.props.isVerified,
    isActive: this.props.isActive
  }

  handleChangeIsVerified = () => {
    const { isVerified } = this.state;
    this.setState({ isVerified: !isVerified });
  }

  handleChangeIsActive = () => {
    const { isActive } = this.state;
    this.setState({ isActive: !isActive });
  }

  render() {
    const {
      classes,
      handleSubmit,
      editUser,
      message,
      error,
      profileImage,
      deleteImage,
      userTypes
    } = this.props;

    const { isVerified, isActive } = this.state;

    const types = userTypes.map(u => {
      return {
        label: u.roleType,
        value: u.roleId
      }
    });
    
    return (
      <React.Fragment>

        {
          (error !== undefined) &&
          <SnackbarContent
            className={classes.error}
            message={
              <span className={classes.message}>
                <ErrorIcon className={`${classes.icon} ${classes.iconVariant}`} />
                {error.toString()}
              </span>
            }
          />
        }

        { message && 
          <Message message={message} isOpen={message ? true : false } />
        }
        <Typography variant="h5" className={classes.title}>Edit User</Typography>

        <Form className={classes.form} onSubmit={handleSubmit(editUser)}>
          <FormControl margin="normal" fullWidth>
            <Field name="tagLine" component={TextField} label="Tag Line" />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="firstName" component={TextField} label="First Name" required />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="lastName" component={TextField} label="Last Name" required />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="phoneNumber" component={TextField} label="Phone" required />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="address" component={TextField} label="Address" required />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="city" component={TextField} label="City" required />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="state" component={TextField} label="State" required />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="zip" component={TextField} label="Zip" required />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="country" component={TextField} label="Country" required />
          </FormControl>

          <FormControl margin="normal" className={classes.textField} required>
            <FormLabel component="legend">User Type</FormLabel>
            <Field 
              name="roleId"
              component={DropDown} 
              helperText="Select User"
              options={types || []}
            />
          </FormControl>

          <FormControl margin="normal" required fullWidth>
            <FormLabel component="legend">Upload Profile Pic</FormLabel>
            <Field 
              name="profilePic" 
              component={UploadField} 
              label="Upload Profile Pic" 
              folderName={USER_FILES_FOLDER}
            />
          </FormControl>

          {
            profileImage &&
            <FilesList
              list={profileImage}
              deleteItem={deleteImage}
              folderName={USER_FILES_FOLDER}
            />
          }

          <FormControl margin="normal" required fullWidth>
            <FormLabel component="legend">Is Verified</FormLabel>
            <Field
              name="isVerified"
              component={Switch}
              checked={isVerified}
              onChange={this.handleChangeIsVerified}
            />
          </FormControl>

          <FormControl margin="normal" required fullWidth>
            <FormLabel component="legend">Is Active</FormLabel>
            <Field
              name="isActive"
              component={Switch}
              checked={isActive}
              onChange={this.handleChangeIsActive}
            />
          </FormControl>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Save User
          </Button>

        </Form>

      </React.Fragment>
    );
  }
}

export default withStyles(styles)(UserForm);